import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../../shared/utility";

const initialState: {
  userInfo: {
    TPA: string;
    memberId: string;
    groupId: number;
    patientName:string;
  };

  error: boolean;
  loading: boolean;
} = {
  userInfo: {
    TPA: "",
    memberId: "",
    groupId: 0,
    patientName:""
  },
  error: false,
  loading: false,
};
const fetchUserInfo = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_USER_INFO_SUCCESS: {
      return updateObject(state, {
        userInfo: action.userInfo,
        error: false,
        loading: false,
      });
    }
    case actionTypes.FETCH_USER_INFO_STARTED:
      return updateObject(state, {
        userInfo: initialState.userInfo,
        error: false,
        loading: true,
      });

    case actionTypes.FETCH_USER_INFO_FAILED:
      return updateObject(state, {
        userInfo: initialState.userInfo,
        error: true,
        loading: false,
      });

    default:
      return state;
  }
};

export default fetchUserInfo;
